export class LogsService {
  private infoData;

  setInfo(data) {
    this.infoData = data;
  }

  get info() {
    return this.infoData;
  }
}
